import { isMobile } from 'react-device-detect';

/** True when the site is opened on a mobile phone (not tablet/desktop). */
export function isMobilePhone(): boolean {
    return isMobile;
}
